import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15287574"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar is-fixed-top",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "burger-menu-overlay"
}
const _hoisted_9 = { class: "navbar-end" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "navbar-item has-dropdown is-hoverable" }
const _hoisted_13 = { class: "navbar-link" }
const _hoisted_14 = { class: "navbar-dropdown is-right" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 6,
  class: "dropdown-divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$config.logoUrl)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'dashboard' },
            class: "navbar-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNav = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "is-rounded",
                src: _ctx.$config.logoUrl
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        role: "button",
        class: _normalizeClass(["navbar-burger", { 'is-active': _ctx.showNav }]),
        "aria-label": "menu",
        "aria-expanded": "false",
        "data-target": "appNavbar",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNav = !_ctx.showNav))
      }, _hoisted_7, 2)
    ]),
    _createElementVNode("div", {
      id: "appNavbar",
      class: _normalizeClass(["navbar-menu", { 'is-active': _ctx.showNav }]),
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showNav = false))
    }, [
      (_ctx.showNav)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.hasMapUrl)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              id: "menu-map",
              to: "/carto",
              class: "navbar-item"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$gettext("Map")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.isLog)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.helpUrl)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.helpUrl,
                    class: "navbar-item"
                  }, _toDisplayString(_ctx.$gettext("Help")), 9, _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.cguUrl)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: _ctx.cguUrl,
                    class: "navbar-item"
                  }, _toDisplayString(_ctx.$gettext("Terms of Service")), 9, _hoisted_11))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                to: "/",
                class: "navbar-item"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$gettext("Sign in")), 1)
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isLog)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_router_link, {
                to: "/dashboard",
                class: "navbar-item"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$gettext("Dashboard")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.userProfile?.name ? _ctx.userProfile.name : _ctx.$gettext("User")), 1),
                _createElementVNode("div", _hoisted_14, [
                  (!_ctx.$config?.hideProfile)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.profilePageUrl,
                        target: "_blank",
                        class: "navbar-item"
                      }, _toDisplayString(_ctx.$gettext("Profile")), 9, _hoisted_15))
                    : _createCommentVNode("", true),
                  (_ctx.hasPreferences)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: "/preferences",
                        class: "navbar-item",
                        id: "menu-preferences"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$gettext("Settings")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.hasUnconfiguredBackend())
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 2,
                        to: "/create-account",
                        class: "navbar-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(!_ctx.$config.disableImportWallet
                    ? _ctx.$gettext("Create or import my wallet")
                    : _ctx.$gettext("Create my wallet")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_16,
                  (_ctx.isLog && _ctx.hasAnyAdminRights)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createVNode(_component_router_link, {
                          to: "/admin-dashboard",
                          class: "navbar-item"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$gettext("Admin dasboard")), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_17
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.helpUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 4,
                        href: _ctx.helpUrl,
                        class: "navbar-item"
                      }, _toDisplayString(_ctx.$gettext("Help")), 9, _hoisted_18))
                    : _createCommentVNode("", true),
                  (_ctx.cguUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 5,
                        href: _ctx.cguUrl,
                        class: "navbar-item"
                      }, _toDisplayString(_ctx.$gettext("Terms of Service")), 9, _hoisted_19))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$modal.open('AboutModal'))),
                    class: "navbar-item",
                    innerHTML: 
                  _ctx.$gettext('About %{ appName }', {
                    appName: _ctx.$appInfo.appName,
                  })
                
                  }, null, 8, _hoisted_20),
                  (_ctx.helpUrl || _ctx.cguUrl)
                    ? (_openBlock(), _createElementBlock("hr", _hoisted_21))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    id: "menu-signout",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                    class: "navbar-item"
                  }, _toDisplayString(_ctx.$gettext("Sign out")), 1)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}